import { XCircleIcon } from '@heroicons/react/24/solid';
import { memo } from 'react';

const ImagePreview = ({
  images,
  onMouseEnter,
  onMouseLeave,
  onRemove,
  themeValue,
  hoveredIndex,
}) => {
  return (
    <>
      {images.length > 0 && (
        <div className="flex gap-3 px-[0.625rem]" key="images_textfield">
          {images.map((image, index) => (
            <div
              key={index}
              className="mt-3 relative cursor-pointer"
              onMouseEnter={() => onMouseEnter(index)}
              onMouseLeave={onMouseLeave}
            >
              <img
                src={image.thumbnail ? image.thumbnail : image.url}
                alt={'Preview-' + index}
                className="w-16 h-16 rounded object-cover"
              />
              <div
                className={`absolute -top-[0.625rem] -right-[0.625rem] ${
                  hoveredIndex === index ? 'visible' : 'invisible'
                }`}
              >
                <XCircleIcon
                  className={`w-5 h-5 ${
                    themeValue == 'dark'
                      ? 'text-crystal-bell'
                      : 'text-raisin-black'
                  }`}
                  onClick={() => onRemove(image)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

const areEqual = (prevProps, nextProps) => {
  return (
    prevProps.images === nextProps.images &&
    prevProps.hoveredIndex === nextProps.hoveredIndex
  );
};

export default memo(ImagePreview, areEqual);
